// Users.js
import React, { useState, useEffect } from 'react';
import './Users.css';
import { getMessages, getUsers, getUserTokensByDate } from './api';
import { updateUser, grantSubscription } from './api';
import { sendMessageToUsers } from './api';
import MessagesModal from '../messages/MessagesModal';

const Users = ({ logOut }) => {
    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
    const [filters, setFilters] = useState({
        email: '', username: '', status: '', source: '', tg_id: '',
        requestsFrom: '', requestsTo: '',
        totalRequestsFrom: '', totalRequestsTo: '',
        dateFrom: '', dateTo: '', audio: '',
    });

    const [selectedUser, setSelectedUser] = useState(null);
    const [newStatus, setNewStatus] = useState('');
    const [newIsAudioAssistant, setNewAudioAssistant] = useState(null);

    // Состояния для выдачи подписки
    const [subscriptionType, setSubscriptionType] = useState('pro_1_month');
    const [durationMonths, setDurationMonths] = useState(1);
    const [grantingSubscription, setGrantingSubscription] = useState(false);


    const [showModal, setShowModal] = useState(false);
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState('');

    const [messages, setMessages] = useState([]);
    const [showMessagesModal, setShowMessagesModal] = useState(false);

    const [payds, setPayds] = useState([]);

    const fetchTokensData = async (userId) => {
        try {
            const data = await getUserTokensByDate(userId);
            if (data) {
                setPayds(data); // Устанавливаем данные в состояние
            }
        } catch (error) {
            console.error('Ошибка при получении данных:', error);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            const data = await getUsers();
            setUsers(data);
            setFilteredUsers(data);
        };
        fetchData();
    }, []);

    // const handleSort = (key) => {
    //     console.log('handleSort', key)
    //     let direction = 'ascending';
    //     if (sortConfig.key === key && sortConfig.direction === 'ascending') {
    //         direction = 'descending';
    //     }
    //     setSortConfig({ key, direction });

    //     const sortedUsers = [...filteredUsers].sort((a, b) => {
    //         if (a[key] < b[key]) return direction === 'ascending' ? -1 : 1;
    //         if (a[key] > b[key]) return direction === 'ascending' ? 1 : -1;
    //         return 0;
    //     });
    //     setFilteredUsers(sortedUsers);
    // };

    const handleSort = (key) => {
        console.log('handleSort', key);
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });

        const sortedUsers = [...filteredUsers].sort((a, b) => {
            let aValue = a[key];
            let bValue = b[key];

            // Проверяем, является ли ключ датой
            if (key === 'date_reg' || key === 'subscription_end_date' || key === 'test_expire_date') {
                aValue = aValue ? new Date(aValue).getTime() : 0;
                bValue = bValue ? new Date(bValue).getTime() : 0;
            } else {
                // Для других ключей, используем стандартное сравнение
                if (typeof aValue === 'string') aValue = aValue.toLowerCase();
                if (typeof bValue === 'string') bValue = bValue.toLowerCase();
            }

            if (aValue < bValue) return direction === 'ascending' ? -1 : 1;
            if (aValue > bValue) return direction === 'ascending' ? 1 : -1;
            return 0;
        });

        setFilteredUsers(sortedUsers);
    };

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleSendMessage = async () => {
        try {
            await sendMessageToUsers(message, file);
            alert('Сообщение отправлено!');
            setShowModal(false);
            setMessage('');
            setFile(null);
        } catch (error) {
            alert(error.message);
        }
    };


    const handleRowClick = (user) => {
        console.log('handleRowClick', user)
        fetchTokensData(user.id)
        setSelectedUser(user);
        if (!user.status) {
            setNewStatus("default")
        } else {
            setNewStatus(user.status); // Предустанавливаем статус пользователя в модальном окне
        }
        setNewAudioAssistant(
            user.isAudioAssistant === 1
                ? true
                : user.isAudioAssistant === 0
                    ? false
                    : null
        );

    };

    const handleStatusChange = (e) => {
        setNewStatus(e.target.value);
    };

    const handleGrantSubscription = async () => {
        if (!selectedUser?.email) {
            alert('У пользователя нет email для выдачи подписки');
            return;
        }
        setGrantingSubscription(true);
        try {
            await grantSubscription(selectedUser.email, subscriptionType, durationMonths);
            alert(`Подписка ${subscriptionType} на ${durationMonths} мес. выдана для ${selectedUser.email}`);
            // Обновляем дату подписки в UI
            // Если есть активная подписка - добавляем к ней, иначе от текущей даты
            const now = new Date();
            const currentSubEnd = selectedUser.subscription_end_date 
                ? new Date(selectedUser.subscription_end_date) 
                : null;
            const baseDate = (currentSubEnd && currentSubEnd > now) ? currentSubEnd : now;
            const newEndDate = new Date(baseDate);
            newEndDate.setMonth(newEndDate.getMonth() + durationMonths);
            setFilteredUsers((prevUsers) =>
                prevUsers.map((user) =>
                    user.id === selectedUser.id
                        ? { ...user, subscription_end_date: newEndDate.toISOString() }
                        : user
                )
            );
            setSelectedUser(prev => ({
                ...prev,
                subscription_end_date: newEndDate.toISOString()
            }));
        } catch (error) {
            alert('Ошибка при выдаче подписки: ' + error.message);
        } finally {
            setGrantingSubscription(false);
        }
    };

    // const handleSave = () => {
    //     // updateUser({ ...selectedUser, status: newStatus });
    //     updateUser({ userId: selectedUser.id, newStatus });
    //     setSelectedUser(null); // Закрываем модалку после сохранения
    // };

    const handleSave = async () => {
        console.log("newstatus:", newStatus)
        const updatedUser = await updateUser({
            userId: selectedUser.id,
            newStatus,
            isAudioAssistant:
                newIsAudioAssistant === true
                    ? 1
                    : newIsAudioAssistant === false
                        ? 0
                        : null
        });

        if (updatedUser) {
            // Обновляем статус в `users` или `filteredUsers`
            setFilteredUsers((prevUsers) =>
                prevUsers.map((user) =>
                    user.id === selectedUser.id ? {
                        ...user,
                        status: newStatus,
                        isAudioAssistant:
                            newIsAudioAssistant === true
                                ? 1
                                : newIsAudioAssistant === false
                                    ? 0
                                    : null
                    } : user
                )
            );
            setSelectedUser(null); // Закрываем модалку после сохранения
        }
    };


    //   const handleFilterChange = (e) => {
    //     const { name, value } = e.target;
    //     console.log('name, value', name, value)
    //     setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));

    //     const filtered = users.filter((user) =>
    //       Object.keys(filters).every((filterKey) =>
    //         user[filterKey].toString().toLowerCase().includes(filters[filterKey].toLowerCase())
    //       )
    //     );
    //     setFilteredUsers(filtered);
    //   };


    // const handleFilterChange = (e) => {
    //     const { name, value } = e.target;

    //     // Обновляем фильтры в состоянии
    //     setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));

    //     // Фильтруем пользователей с учетом новых значений
    //     const filtered = users.filter((user) =>
    //         (!name || name !== 'username' || user.username.toLowerCase().includes(value.toLowerCase())) &&
    //         (!name || name !== 'status' || user.status.toLowerCase().includes(value.toLowerCase())) &&
    //         (!name || name !== 'source' || user.source.toLowerCase().includes(value.toLowerCase()))
    //     );

    //     setFilteredUsers(filtered);
    // };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;

        setFilters((prevFilters) => {
            const updatedFilters = { ...prevFilters, [name]: value };

            const filtered = users.filter((user) => {
                const matchesUserEmail = (user.email || '').toLowerCase().includes(updatedFilters.email.toLowerCase());
                const matchesUsername = (user.username || '').toLowerCase().includes(updatedFilters.username.toLowerCase());
                const matchesStatus = (user.status || '').toLowerCase().includes(updatedFilters.status.toLowerCase());
                const matchesSource = (user.source?.[0] || '').toLowerCase().includes(updatedFilters.source.toLowerCase());
                const matchesTgId = (user.user_tg_id || '').toString().toLowerCase().includes(updatedFilters.tg_id.toLowerCase());

                const todayMessageCount = user.today_message_count || 0;
                const totalMessageCount = user.message_count || 0;

                const matchesRequests = (
                    (!updatedFilters.requestsFrom || todayMessageCount >= parseInt(updatedFilters.requestsFrom)) &&
                    (!updatedFilters.requestsTo || todayMessageCount <= parseInt(updatedFilters.requestsTo))
                );

                const matchesTotalRequests = (
                    (!updatedFilters.totalRequestsFrom || totalMessageCount >= parseInt(updatedFilters.totalRequestsFrom)) &&
                    (!updatedFilters.totalRequestsTo || totalMessageCount <= parseInt(updatedFilters.totalRequestsTo))
                );

                const userDateReg = user.date_reg ? new Date(user.date_reg).toISOString().split('T')[0] : '';

                const matchesDateFrom = (!updatedFilters.dateFrom || userDateReg >= updatedFilters.dateFrom);
                const matchesDateTo = (!updatedFilters.dateTo || userDateReg <= updatedFilters.dateTo);

                const matchesAudio = (
                    updatedFilters.audio === '' ||
                    (updatedFilters.audio === 'true' && user.isAudioAssistant) ||
                    (updatedFilters.audio === 'false' && !user.isAudioAssistant) ||
                    (updatedFilters.audio === 'null' && (user.isAudioAssistant === null || user.isAudioAssistant === undefined))
                );




                return matchesUserEmail && matchesUsername && matchesStatus && matchesSource && matchesTgId &&
                    matchesRequests && matchesTotalRequests && matchesDateFrom && matchesDateTo && matchesAudio;
            });

            setFilteredUsers(filtered);
            return updatedFilters;
        });
    };


    const handleOpenMessages = async () => {
        try {
            const userMessages = await getMessages(selectedUser.email); // Передаем ID пользователя
            setMessages(userMessages);
            setShowMessagesModal(true);
        } catch (error) {
            console.error("Ошибка при загрузке сообщений:", error);
        }
    };

    const handleLogOut = async () => {
        localStorage.removeItem('authData');
        logOut()
    }

    const tableHeaderStyle = {
        padding: '8px',
        textAlign: 'left',
        borderBottom: '2px solid #ddd'
    };

    const tableCellStyle = {
        padding: '8px',
        borderBottom: '1px solid #ddd'
    };

    return (
        <div className="table-container-adm">
            {/* <h1>Users</h1> */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h1>Пользователи: <span className='q_users'>{` Всего: ${users.length}    Отфильтровано: ${filteredUsers.length}`}</span></h1>
                <button onClick={() => setShowModal(true)}>Рассылка</button>
                <button onClick={handleLogOut}>Выйти</button>
            </div>
            {showModal && (
                <div className="modal">
                    <div className="modal-content">
                        <h2>Отправить сообщение пользователям</h2>
                        <textarea
                            placeholder="Введите сообщение"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            rows="4"
                            style={{ width: '100%' }}
                        ></textarea>
                        <label>
                            <input type="file" onChange={handleFileChange} />
                        </label>
                        {file && <p>Выбран файл: {file.name}</p>}
                        <button onClick={handleSendMessage}>Отправить</button>
                        <button onClick={() => setShowModal(false)}>Закрыть</button>
                    </div>
                </div>
            )}

            {/* <div className="filter-container">
                <label>
                    Username:
                    <input
                        type="text"
                        name="username"
                        value={filters.username}
                        onChange={handleFilterChange}
                        placeholder="Filter by username"
                    />
                </label>
                <label>
                    Status:
                    <input
                        type="text"
                        name="status"
                        value={filters.status}
                        onChange={handleFilterChange}
                        placeholder="Filter by status"
                    />
                </label>
                <label>
                    Source:
                    <input
                        type="text"
                        name="source"
                        value={filters.source}
                        onChange={handleFilterChange}
                        placeholder="Filter by source"
                    />
                </label>
            </div> */}

            <div className="filter-container">
                <label className='filter_label'>
                    Email:
                    <input
                        type="text"
                        name="email"
                        value={filters.email}
                        onChange={handleFilterChange}
                        placeholder="Фильтр по Email"
                    />
                </label>
                <label className='filter_label'>
                    Имя:
                    <input
                        type="text"
                        name="username"
                        value={filters.username}
                        onChange={handleFilterChange}
                        placeholder="Фильтр по имени"
                    />
                </label>
                <label className='filter_label'>
                    TG_ID:
                    <input
                        type="text"
                        name="tg_id"
                        value={filters.tg_id}
                        onChange={handleFilterChange}
                        placeholder="Фильтр по TG_ID"
                    />
                </label>
                <label className='filter_label'>
                    Статус:
                    <input
                        type="text"
                        name="status"
                        value={filters.status}
                        onChange={handleFilterChange}
                        placeholder="Фильтр по статусу"
                    />
                </label>
                {/* <label className='filter_label'>
                    Запросы:
                    <input
                        type="text"
                        name="requests"
                        value={filters.requests}
                        onChange={handleFilterChange}
                        placeholder="Фильтр по запросам"
                    />
                </label>

                <label className='filter_label'>
                    Всего запросов:
                    <input
                        type="text"
                        name="totalRequests"
                        value={filters.totalRequests}
                        onChange={handleFilterChange}
                        placeholder="Фильтр по общему количеству запросов"
                    />
                </label> */}

                <label className='filter_label'>
                    Запросы:
                    <input
                        type="number"
                        name="requestsFrom"
                        value={filters.requestsFrom}
                        onChange={handleFilterChange}
                        placeholder="От"
                    />
                    <input
                        type="number"
                        name="requestsTo"
                        value={filters.requestsTo}
                        onChange={handleFilterChange}
                        placeholder="До"
                    />
                </label>

                <label className='filter_label'>
                    Всего запросов:
                    <input
                        type="number"
                        name="totalRequestsFrom"
                        value={filters.totalRequestsFrom}
                        onChange={handleFilterChange}
                        placeholder="От"
                    />

                    <input
                        type="number"
                        name="totalRequestsTo"
                        value={filters.totalRequestsTo}
                        onChange={handleFilterChange}
                        placeholder="До"
                    />
                </label>


                <label className='filter_label'>
                    Источник:
                    <input
                        type="text"
                        name="source"
                        value={filters.source}
                        onChange={handleFilterChange}
                        placeholder="Фильтр по источнику"
                    />
                </label>
                <label className='filter_label'>
                    Дата начало:
                    <input
                        type="date"
                        name="dateFrom"
                        value={filters.dateFrom}
                        onChange={handleFilterChange}
                    />
                </label>
                <label className='filter_label'>
                    Дата конец:
                    <input
                        type="date"
                        name="dateTo"
                        value={filters.dateTo}
                        onChange={handleFilterChange}
                    />
                </label>
                <label className='filter_label'>
                    Audio:
                    <select name="audio" value={filters.audio} onChange={handleFilterChange}>
                        <option value="">Все</option>
                        <option value="true">True</option>
                        <option value="false">False</option>
                        <option value="null">Null</option>
                    </select>
                </label>
            </div>


            <table className="users-table-adm">
                <thead>
                    <tr>
                        <th>№</th>
                        <th style={{ display: 'none' }} onClick={() => handleSort('id')}>ID</th>
                        <th onClick={() => handleSort('username')}>Email</th>
                        <th onClick={() => handleSort('username')}>TG Name</th>
                        <th onClick={() => handleSort('user_tg_id')}>TG ID</th>
                        <th onClick={() => handleSort('status')}>Статус</th>
                        <th onClick={() => handleSort('qq')}>Запросы</th>
                        <th onClick={() => handleSort('qq')}>Всего запросов</th>
                        <th onClick={() => handleSort('qq')}>Токены 5р</th>
                        <th onClick={() => handleSort('qq')}>Токены 0.1р</th>
                        <th onClick={() => handleSort('qq')}>Баланс руб</th>
                        {/* <th onClick={() => handleSort('status_dialog')}>Status Dialog</th> */}
                        <th onClick={() => handleSort('source')}>Источник</th>
                        <th onClick={() => handleSort('date_reg')}>Дата регистрации</th>
                        <th onClick={() => handleSort('subscription_end_date')}>Подписка до</th>
                        <th onClick={() => handleSort('key')}>Ключ</th>
                        <th onClick={() => handleSort('key_now')}>Действует</th>
                        <th>Audio</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredUsers.map((user, index) => (
                        <tr
                            key={
                                user.email && user.email.trim() !== ''
                                    ? `email-${user.email}`
                                    : `tg-${user.user_tg_id?.[0]}`
                            }
                            onClick={() => handleRowClick(user)}
                        >

                            <td>{index + 1}</td>
                            <td style={{ display: 'none' }}>{user.id}</td>
                            {/* <td>{user.username}</td> */}
                            <td>{user.email}</td>
                            <td>{user.tg_name}</td>
                            <td>{user.user_tg_id[0] || user.user_tg_id[1]}</td>
                            <td>{user.status}</td>
                            <td>{user.today_message_count}</td>



                            <td>{user.message_count}</td>
                            <td>{user.total_tokens5}</td>
                            <td>{user.total_tokens01}</td>
                            <td>{user.balance}</td>
                            {/* <td>{user.status_dialog}</td> */}
                            <td>{user.source}</td>
                            <td>{user.date_reg ? user.date_reg.slice(0, 10) : user.created_at ? user.created_at.slice(0, 10) : ''}</td>
                            {/* <td>{user.subscription_end_date ? user.subscription_end_date.slice(0, 10): ''}</td> */}
                            <td style={{
                                color: (
                                    (user.subscription_end_date && new Date(user.subscription_end_date) < new Date()) ||
                                    (!user.subscription_end_date && user.test_expire_date && new Date(user.test_expire_date) < new Date())
                                ) ? 'gray' : 'inherit'
                            }}>
                                {
                                    user.subscription_end_date
                                        ? user.subscription_end_date.slice(0, 10)
                                        : user.test_expire_date
                                            ? `ТЕСТ до: ${new Date(user.test_expire_date).toLocaleString('ru-RU', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                            })}`
                                            : ''
                                }
                                <br />
                                <span style={{
                                    fontSize: '0.8em',
                                    color: user.has_auto_payment || user.test_status === 'active' ? 'green' : 'gray'
                                }}>
                                    {user.has_auto_payment || user.test_status === 'active' ? 'Карта привязана' : 'Карта не привязана'}
                                </span>
                            </td>


                            <td>{user.has_key ? "✅ Есть" : "❌ Нет"}</td>
                            <td>{user.is_key_active ? "🟢 Активен" : "🔴 Неактивен"}</td>
                            <td>
                                {user.isAudioAssistant === undefined || user.isAudioAssistant === null
                                    ? "null"
                                    : user.isAudioAssistant
                                        ? "true"
                                        : "false"}
                            </td>


                        </tr>
                    ))}
                </tbody>
            </table>

            {selectedUser && !showMessagesModal && (
                <div className="modal">
                    <div className="modal-content">
                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px' }}>
                            <div className='user_info'>
                                <h2>Карточка пользователя</h2>
                                <p><strong>ID:</strong> {selectedUser.id}</p>
                                {/* <p><strong>Имя:</strong> {selectedUser.username}</p> */}
                                <p><strong>Имя:</strong> {selectedUser.email}</p>
                                <p><strong>TG ID:</strong> {selectedUser.user_tg_id}</p>
                                <p><strong>Источник:</strong> {selectedUser.source}</p>
                                <label>
                                    Статус:
                                    <select value={newStatus} onChange={handleStatusChange}>
                                        <option value="default">Default</option>
                                        <option value="manager">Manager</option>
                                        <option value="unlimited">Unlimited</option>
                                        <option value="blocked">Blocked</option>
                                    </select>

                                </label>
                                <label>
                                    Audio Assistant:
                                    <select
                                        value={
                                            newIsAudioAssistant === null
                                                ? 'null'
                                                : newIsAudioAssistant
                                                    ? 'true'
                                                    : 'false'
                                        }
                                        onChange={(e) => {
                                            const v = e.target.value;
                                            setNewAudioAssistant(
                                                v === 'true' ? true : v === 'false' ? false : null
                                            );
                                        }}
                                    >
                                        <option value="true">True</option>
                                        <option value="false">False</option>
                                        <option value="null">Null</option>
                                    </select>
                                </label>

                                <div className='subscription_grant'>
                                    <h4>Выдать подписку</h4>
                                    <p><strong>Текущая подписка до:</strong> {selectedUser.subscription_end_date ? selectedUser.subscription_end_date.slice(0, 10) : 'Нет'}</p>
                                    <label>
                                        Тип подписки:
                                        <select value={subscriptionType} onChange={(e) => setSubscriptionType(e.target.value)}>
                                            <option value="standard_1_month">Standard 1 месяц</option>
                                            <option value="standard_12_months">Standard 12 месяцев</option>
                                            <option value="pro_1_month">Pro 1 месяц</option>
                                            <option value="pro_12_months">Pro 12 месяцев</option>
                                        </select>
                                    </label>
                                    <label>
                                        Длительность (мес.):
                                        <input
                                            type="number"
                                            min="1"
                                            max="36"
                                            value={durationMonths}
                                            onChange={(e) => setDurationMonths(parseInt(e.target.value) || 1)}
                                            style={{ width: '60px' }}
                                        />
                                    </label>
                                    <button
                                        onClick={handleGrantSubscription}
                                        disabled={grantingSubscription || !selectedUser?.email}
                                        style={{ backgroundColor: '#4CAF50', color: 'white', marginTop: '10px' }}
                                    >
                                        {grantingSubscription ? 'Выдаётся...' : 'Выдать подписку'}
                                    </button>
                                </div>

                                <div className='cntr_btn'>
                                    <button onClick={handleSave}>Сохранить</button>
                                    <button onClick={() => setSelectedUser(null)}>Закрыть</button>
                                    <button onClick={handleOpenMessages}>Переписка</button>
                                </div>
                            </div>
                            <div className='payds_info'>
                                <h5>Список токенов по датам</h5>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr style={{ background: '#f9f9f9', borderBottom: '2px solid #ddd', fontSize: '12px' }}>
                                            <th style={tableHeaderStyle}>Дата</th>
                                            <th style={tableHeaderStyle}>Токены 5</th>
                                            <th style={tableHeaderStyle}>Токены 01</th>
                                            <th style={tableHeaderStyle}>Сумма в рублях</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {payds.length > 0 ? (
                                            payds.map((payd, index) => {
                                                const formattedDate = new Intl.DateTimeFormat('ru-RU').format(new Date(payd.date));
                                                return (
                                                    <tr key={index} style={{ borderBottom: '1px solid #ddd', fontSize: '12px' }}>
                                                        <td style={tableCellStyle}>{formattedDate}</td>
                                                        <td style={tableCellStyle}>{payd.total_tokens5}</td>
                                                        <td style={tableCellStyle}>{payd.total_tokens01}</td>
                                                        <td style={tableCellStyle}>{payd.total_rub}</td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="4" style={{ textAlign: 'center', padding: '10px' }}>Нет данных</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>

                </div>
            )}

            <MessagesModal
                show={showMessagesModal}
                onClose={() => setShowMessagesModal(false)}
                messages={messages}
                setMessages={setMessages}
                selectedUser={selectedUser}
            />

        </div>
    );
};

export default Users;

